import React from 'react';
import { IPayPalButtonProps } from '../PayPalButton.types';
import NewPayPalButton from './NewPayPalButton/NewPayPalButton';
import OldPayPalButton from './OldPayPalButton/OldPayPalButton';

const PayPalButton: React.FC<IPayPalButtonProps> = props => {
  const { shouldUseNewPayPalApi } = props;

  return shouldUseNewPayPalApi ? (
    <NewPayPalButton {...props} />
  ) : (
    <OldPayPalButton {...props} />
  );
};

export default PayPalButton;
